import type { OptionApiModel, QuestionApiModel } from '@api_patient/generated/clientv2/models';
import { FormOption } from './_form_option';
import { DynamicFormAnswer } from '@api_patient/dynamic_forms_api.service';
// import type { OptionApiModel } from '@src/api/models/OptionApiModel';
// import type { QuestionApiModel } from '@src/api/models/QuestionApiModel';
// import type { AnswerApiModel } from '@src/api/models/AnswerApiModel';

// TODO: Use this when not injected anymore...
// export type ValidQuestionId = `${typeof FormQuestionBase.ID_PREFIX}${number}`;
export type ValidQuestionId = string;

export abstract class FormQuestionBase {
	// Needs to use non id numbers. Seems to follow other specs that indicates
	// that only [a-zA-Z0-9] and ISO 10646 characters U+00A0 and higher, plus the
	// hyphen (-) and the underscore (_) are allowed.
	public static readonly ID_PREFIX = 'DFQ_';

	public readonly header: string;
	public readonly description: string;
	public readonly isRequired: boolean;
	public readonly id: ValidQuestionId;
	public readonly placeholder: string;

	constructor(question: QuestionApiModel) {
		this.id = this.parseQuestionId(question.Id);
		this.isRequired = question.Required;

		// TODO PAT-426: Allow null?
		this.header = question.Header ?? '';
		// TODO PAT-426: Allow null?
		this.description = question.Description ?? '';
		// TODO PAT-426: Allow null?
		this.placeholder = question.Placeholder ?? '';
	}

	public composeQuestionId(id?: ValidQuestionId): number {
		const int = (id ?? this.id).replace(FormQuestionBase.ID_PREFIX, '');

		return parseInt(int, 10);
	}

	public parseQuestionId(id: number): ValidQuestionId {
		return `${FormQuestionBase.ID_PREFIX}${id}`;
	}

	protected parseQuestions(options: OptionApiModel[]): FormOption[] {
		return options.map((option) => new FormOption(option));
	}

	// For override so it's exposed correctly the facade level.
	protected getAnswer(_: FormElements<string>): DynamicFormAnswer {
		throw new Error('getAnswer is not implemented on the implementor');
	}

	// For override so it's exposed correctly the facade level.
	protected setDefault(_: Readonly<DynamicFormAnswer[]>): void {
		throw new Error('setDefault is not implemented on the implementor');
	}

	protected createAnswerApiModel({
		boolValue,
		choices,
		intValue,
		stringValue,
	}: {
		stringValue?: string | null;
		intValue?: number | null;
		boolValue?: boolean | null;
		choices?: number[] | null;
	}): DynamicFormAnswer {
		return {
			questionId: this.composeQuestionId(),
			boolValue: boolValue ?? null,
			choices: choices ?? [],
			intValue: intValue ?? null,
			stringValue: stringValue ?? null,
		};
	}
}
